'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringTemplate = require('string-template');

var _stringTemplate2 = _interopRequireDefault(_stringTemplate);

var _utils = require('../../utils');

var _icons = require('../icons');

var _icons2 = _interopRequireDefault(_icons);

var _tpl = require('./tpl');

var _tpl2 = _interopRequireDefault(_tpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CenterControl = function () {
  function CenterControl(elVideo, options) {
    _classCallCheck(this, CenterControl);

    this.elVideo = elVideo;
    this.options = options || {};

    this.render();
    this.bindEvents();
  }

  CenterControl.prototype.render = function render() {
    var tplData = {};
    Object.keys(_icons2['default']).forEach(function (key) {
      return tplData['icon_' + key] = _icons2['default'][key];
    });
    this.element = (0, _utils.createElement)((0, _stringTemplate2['default'])(_tpl2['default'], tplData));

    // 中间播控按钮支持设置大小
    if (this.options.centerControlSize) {
      var btnSize = Number(this.options.centerControlSize);
      btnSize = btnSize ? btnSize + 'px' : btnSize;
      this.element.querySelector('.center-wrapper').style.width = btnSize;
    }
    if (this.options.showCenterControl === 'error') {
      (0, _utils.addClassName)(this.element, 'only-error');
    } else {
      this.elPlay = this.element.querySelector('.play-button');
    }
    this.orgClsName = this.element.className;
    this.elRefresh = this.element.querySelector('.refresh-button');
    this.elVideo.parentNode.appendChild(this.element);
  };

  CenterControl.prototype.bindEvents = function bindEvents() {
    var _this = this;

    if (this.elPlay) {
      this.elVideo.addEventListener('play', function () {
        _this.elPlay.style.display = 'none';
      });
      this.elVideo.addEventListener('pause', function () {
        _this.elPlay.style.display = '';
      });
    }

    // 视频点击暂停/播放
    if (this.options.showCenterControl !== 'manual') {
      this.element.addEventListener('click', function () {
        if (_this.elVideo.paused) {
          _this.elVideo.play();
        } else {
          _this.elVideo.pause();
        }
      });
    }

    // loading展示逻辑
    var waitingTimer = void 0;
    this.elVideo.addEventListener('waiting', function () {
      clearTimeout(waitingTimer);
      waitingTimer = setTimeout(function () {
        return _this.setClassName('loading');
      }, _this.elVideo.seeking ? _utils.CONSTS.SEEK_WAIT_TIME : _utils.CONSTS.MAX_WAIT_TIME);
    });
    this.elVideo.addEventListener('seeked', function () {
      clearTimeout(waitingTimer);
      _this.setClassName('');
    });
    this.elVideo.addEventListener('error', function () {
      clearTimeout(waitingTimer);
      _this.setClassName('error');
    });
    this.elVideo.addEventListener('stalled', function () {
      clearTimeout(waitingTimer);
      _this.setClassName('error');
    });
    this.elVideo.addEventListener('playing', function () {
      clearTimeout(waitingTimer);
      _this.setClassName('');
    });
    this.elVideo.addEventListener('pause', function () {
      clearTimeout(waitingTimer);
      (0, _utils.removeClassName)(_this.element, 'loading');
    });

    var isMetaListened = void 0;
    this.elRefresh.addEventListener('click', function (ev) {
      if (!isMetaListened) {
        (0, _utils.once)(_this.elVideo, 'loadedmetadata', function () {
          _this.elVideo.play();
          isMetaListened = false;
        });
        isMetaListened = true;
      }
      _this.elVideo.load();
      _this.setClassName('loading');
      ev.stopPropagation();
    });
  };

  CenterControl.prototype.setClassName = function setClassName(name) {
    this.element.className = (this.orgClsName + ' ' + name).trim();
  };

  return CenterControl;
}();

exports['default'] = CenterControl;
module.exports = exports['default'];